/* eslint-disable no-unused-vars */
import React, {
  Component,
  useState,
  useRef,
  useEffect,
  useCallback,
  useContext,
} from 'react';
// import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */

import HeaderClose from './header/HeaderClose';

const HeaderCloseNode = ({ isCloseBtnDisable, action }) => {
  const onClick = useCallback(
    event => {
      event.preventDefault();
      if (typeof action === 'function') {
        action.call(this);
      }
    },
    [action]
  );

  return (
    !isCloseBtnDisable && (
      <HeaderClose data-testid="HeaderClose" onClick={onClick} />
    )
  );
};

export default HeaderCloseNode;



// WEBPACK FOOTER //
// ./src/phase2/survey/page/inquiry/node/HeaderCloseNode.js